<template>
	<div class="resPassword" ref="middle_page">
		<span class="resPassword-span"></span>
		<div class="resPassword-div">
			<div class="resPassword-div1" v-if="resPasswordState">
				<h1>{{$t('email.title')}}</h1>
				<br />
				<div class="leftdiv"> {{$t('personSet.newPass')}}:</div>
				<div class="rightdiv"><input
					id="newPassword"
					type="password"
					:placeholder="$t('personSet.placeholder')"
					v-model="newPassword"
					autocomplete="new-password"
					maxlength="16"
				/></div>
				<br />
				<div class="leftdiv">{{$t('personSet.repeatPass')}}:</div>
				<div class="rightdiv"><input
					id="repeatPassword"
					type="password"
					:placeholder="$t('personSet.placeholder')"
					v-model="repeatPassword"
					autocomplete="new-password"
					maxlength="16"
				/></div>
				<button @click="resetPassword">{{$t('rePassword.confirm')}}</button>
			</div>
			<!-- 密码修改成功页面 -->
			<div class="resPassword-div2" v-if="!resPasswordState">
				<h1>{{$t('email.title')}}</h1>
				<p>{{message}}</p>
				<button @click="goHome">{{$t('active.goHome')}}</button>
			</div>
		</div>
	</div>
</template>

<script>
	import md5 from "js-md5";
	export default {
		name: 'resPassword',
		data() {
			return {
				resPasswordState: true,
				message: "",
				userId: "",
				newPassword: "",
				repeatPassword: ""
			}
		},
		mounted() {
			//获取设备屏幕的高度
			const h = document.body.clientHeight - 299
			this.$refs.middle_page.style.minHeight = h + "px";
			
			//修改状态
			this.$api.post("/register/delActivityToken", {
				"token": this.$route.query.token
			}).then(
				(response) => {
					if (response.data) {
						this.userId = response.data.userId;
						this.resPasswordState = true;
					} else {
						this.resPasswordState = false;
						this.message = window.vm.$i18n.t("register_email.timeout");
					}
				}
			)
		},
		methods: {
			//更新密码
			resetPassword: function() {
				//验证密码不是空白
				if (this.newPassword == "") {
					this.$el_alert_type(
					window.vm.$i18n.t("personSet.passwordNotNull"),
					"warning"
					);
					return;
				}

				if (this.repeatPassword == "") {
					this.$el_alert_type(window.vm.$i18n.t("js.repeatPassword"), "warning");
					return;
				}

				//验证密码
				let passReg = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/);
				if (!passReg.test(this.newPassword)) {
					this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
					return;
				}
				passReg = new RegExp(/^[a-zA-Z0-9_+-=*#%$]+$/);
				if (!passReg.test(this.newPassword)) {
					this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
					return;
				}

				//验证两次密码是否一致
				if (this.newPassword != this.repeatPassword) {
					this.$el_alert_type(window.vm.$i18n.t("register_email.checkMessage"), "warning");
					return;
				}
				//更新密码
				this.$api.post("/register/updateForgottenPwd", {
					"password": md5(this.newPassword),
					"userId": this.userId
				}).then(
					(response) => {
						this.resPasswordState = false;
						this.message = window.vm.$i18n.t("register_email.passwordResetSuccess");
					}
				)
			},

			//跳到主页
			goHome: function() {
				this.$router.push("/home");
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.resPassword {
		background-color: #fff;
		height: 650px;
		position: absolute;
		/* background-image: url(https://static.wixstatic.com/media/a36401_daf7afb57f9c4561abef96257d85b524~mv2_d_3500_3500_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_daf7afb57f9c4561abef96257d85b524~mv2_d_3500_3500_s_4_2.webp);
      background-size: 650px auto;
      background-repeat: no-repeat;
      background-position-x:50%; */
		/* background-image: url(../../../static/images/bg/ball_bg.jpg); */
		background-repeat: no-repeat;
		background-size: cover;
		position: relative;
		background-position: center center;

	}

	.resPassword-span {
		position: absolute;
		top: 0;
		left: 0;
		height:100%;
		width: 100%;
		/* background-color: rgba(0, 0, 0, .5); */
	}

	.resPassword-div {
		position: absolute;
		left: 50%;
		top: 50%;
    	transform: translate(-50%, -50%);
		width: 980px;
		height: 100%;
		color: #fff;
	}

	.resPassword-div1 {
		width: 500px;
		background-color: #fff;
		border-radius: 20px;
		text-align: center;
		padding-top: 30px;
		padding-left: 30px;
		padding-right: 30px;
		padding-bottom: 50px;
		position: absolute;
		left: 50%;
		top: 50%;
    	transform: translate(-50%, -50%);
		box-shadow: 0 1px 10px 1px rgb(0 0 0 / 45%);
		color: #0071c5;
	}

	/* .resPassword-div1 h1 {
		font-size: 19px;
		font-weight: 500;
		margin-bottom: 10px;
		font-family: myFont3;
	} */

	.resPassword-div1 h1 span {
		font-family: braggadocio;
		color: #FF5252;
	}

	/* .resPassword-div1 input {
		    margin-top: 20px;
		padding: 8px 10px 10px;
		font-size: 12px;
		background: #fff!important;
		border: 1px solid #0071c5!important;
		border-radius: 4px!important;
		color: #1a1a1a!important;
	} */
	.leftdiv {
		/* width: 200px; */
		margin-top: 20px;
		color:#1a1a1a!important;
		font-size:14px!important;
		/* padding: 8px 10px 10px 10px; */
		float: left;
		/* text-align: right; */
		text-align: left;
	}
	.rightdiv {
		float: left;
		text-align: left;
		/* width:calc(100% - 200px)!important; */
		width: 100%;
    	margin-bottom: 20px;
	}

	.resPassword-div1 input {
		width: 100%!important;
		line-height: 12px;
		margin-top: 10px;
		padding: 8px 10px 10px 10px;
		font-size: 12px;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		background:#fff!important;
		border:1px solid #0071c5!important;
		border-radius:4px!important;
		color:#1a1a1a!important;
	}

	.resPassword-div1 button {
		margin-top: 30px;
		padding: 6.5px 15px 8.5px 15px;
		border: solid rgba(250, 250, 250, 1) 1px;
		border-radius: 20px;
		color: #FAFAFA;
		line-height: 13px;
		transition: 0.5s ease;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-style: normal;
		width: 120px;
		height: 36px;
		font-size: 14px;
		font-weight: bold;
		background: #0071c5;
	}

	.resPassword-div1 button:hover {
		transition: 0.5s ease;
		background-color: #007aff;
		color: #FAFAFA;
	}

	.resPassword-div1 p {
		margin-top: 20px;
		font-size: 30px;
		color: #e8e6e6;
		text-align: center;
		margin-bottom: 90px;
		text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
	}
	.resPassword-div2 {
		width: 500px;
		background-color: #fff;
		border-radius: 20px;
		text-align: center;
		padding-top: 30px;
		padding-left: 30px;
		padding-right: 30px;
		padding-bottom: 30px;
		position: absolute;
		left: 50%;
		top: 50%;
    	transform: translate(-50%, -50%);
		box-shadow: 0 1px 10px 1px rgb(0 0 0 / 45%);
		color: #0071c5;
	}
	.resPassword-div2 p {
		color: #000;
		font-size: 14px;
		font-family: jura;
		line-height: 30px;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
		margin-top:20px;
		margin-right:10px;
		text-align:left;
	}
	.resPassword-div2 button {
		margin-top: 60px;
		padding: 6.5px 15px 8.5px 15px;
		background-color: #0071c5;
		border: solid rgba(250, 250, 250, 1) 1px;
		border-radius: 20px;
		font-size:13px;
		color: #FAFAFA;
		line-height: 13px;
		transition: 0.5s ease;
		font-family: source-han-sans-simplified-c, sans-serif;
		font-weight: 200;
		font-style: normal;
	}

	.resPassword-div2 button:hover {
		transition: 0.5s ease;
		background-color: #007aff;
		color: #FAFAFA;
	}
	.resPassword-div1 p:nth-child(3) {
		margin-bottom: 30px;
	}
	@media (max-width: 834px) {
		.resPassword-div {
			width: 96%!important;
			top: 30%!important;
		}
		.resPassword-div1 {
			width: 100%!important;
			position: fixed!important;
		}
		.resPassword-div1 input {
			margin-top: 10px!important;
		}
		.resPassword-div2 {
			width: 100%!important;
			position: fixed!important;
		}
		.rightdiv{width:100%!important}
		.leftdiv{width:100%!important;padding-bottom: 0px!important;}
	}
	@media (max-width: 480px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/content/resPassword.vue